import type { FmTableColumn } from '../../types/fm-table';

const cx = (...parts: Array<string | false | null | undefined>): string =>
  parts.filter(Boolean).join(' ');

const ROLE_CLASS: Partial<Record<NonNullable<FmTableColumn<unknown>['role']>, string>> = {
  numeric: 'fm-table__col--numeric',
  money: 'fm-table__col--money',
  delta: 'fm-table__col--delta',
  status: 'fm-table__col--status',
  source: 'fm-table__col--source',
  metadata: 'fm-table__col--metadata',
  actions: 'fm-table__col--actions',
  label: 'fm-table__col--label',
};

export function columnClassName<T>(col: FmTableColumn<T>, extra?: string): string {
  const roleClass = col.role ? ROLE_CLASS[col.role] : undefined;
  // Money/delta/numeric roles imply right-aligned tabular numerics, matching
  // the legacy `numeric` flag so protected value columns render consistently.
  const roleIsNumeric = col.role === 'numeric' || col.role === 'money' || col.role === 'delta';
  return cx(
    extra,
    (col.numeric || roleIsNumeric || col.dataValue) && 'fm-table__num',
    roleClass,
    col.dataValue && 'fm-table__cell--data-value',
    col.flushInline && 'fm-table__cell--flush-inline',
    col.truncate && 'fm-table__cell--truncate',
    col.mobileHidden && 'fm-table__col--mobile-hidden',
    col.className,
  );
}
